module.exports = __webpack_public_path__ + "media/images/footer-insta-icon-8564a2ef3379aa77109a3794447293b4.png";